import Color from "color";
import { WidgetNoteStyleLegcyToNewBG } from "./useNoteWidgetStyle";

export const pageForegroundColor = (
  page: "ADD" | { image?: any; backgroundColor?: string | null }
) => {
  if (page === "ADD") {
    return "DARK";
  }
  if (page.image) {
    return "LIGHT";
  }

  if (
    page.backgroundColor &&
    Color(
      WidgetNoteStyleLegcyToNewBG[page.backgroundColor] ?? page.backgroundColor
    ).isDark()
  ) {
    return "LIGHT";
  }
  return "DARK";
};
